import { apiPut } from "../baseApi";
import { setUserData } from "service/mapper";

export const update = async (id, data) => {
  try {
    const response = await apiPut("_user", id, data);
    const userData = setUserData(response.data);
    if(!!data.district_id && userData.tags.length) {
      userData.tags = userData.tags.filter(el => el.district_id === data.district_id);
    }
    return { ...response, data: userData };
  } catch (error) {
    return Promise.reject(error);
  }
};
